<div class="content-insights">
  <div class="wrapper-boxes">
    <div class="wrapper-box-insight" style="margin-right: 0px;" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.likes)">
      <div class="wrapper-icon blue">
        <img src="./assets/icons/insights/icon-insights-likes.svg" alt="">
      </div>
      <span class="value">{{insightsListOverview?.total_lyst_likes | number}}</span>
      <span class="label">{{'INSIGHTS.total_list_likes' | translate}}</span>
    </div>
  </div>
  <div class="wrapper-boxes">
    <div class="wrapper-box-insight" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.views)">
      <div class="wrapper-icon orange">
        <img src="./assets/icons/insights/icon-insights-list-views.svg" alt="">
      </div>
      <span class="value">{{insightsListOverview?.total_lyst_views | number}}</span>
      <span class="label">{{'INSIGHTS.total_list_views' | translate}}</span>
    </div>
    <div class="wrapper-box-insight" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.shares)">
      <div class="wrapper-icon blue-light">
        <img src="./assets/icons/insights/icon-insights-list-shares.svg" alt="">
      </div>
      <span class="value">{{insightsListOverview?.total_lyst_shares | number}}</span>
      <span class="label">{{'INSIGHTS.total_list_shares' | translate}}</span>
    </div>
  </div>
</div>
